import { render } from "./GoogleCallback.vue?vue&type=template&id=5ae89f82&scoped=true"
import script from "./GoogleCallback.vue?vue&type=script&lang=js"
export * from "./GoogleCallback.vue?vue&type=script&lang=js"

import "./GoogleCallback.vue?vue&type=style&index=0&id=5ae89f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae89f82"]])

export default __exports__